import template from './upsell.html';

let component = {
	template: template,
	bindings: {
		product: '=',
		modal: '='
	},
	controller: function(
		Filter, 
		$ionicHistory,
		$ionicScrollDelegate,
		$state,
		$scope
	) {
		"ngInject"

		var vm = this;

		vm.toCategory = (id) => {
			Filter.setAllActives({
				categories: [id]
			});
			$ionicHistory.nextViewOptions({
				historyRoot: true,
				disableBack: true
			});
			$state.go('tab.search');
			Filter.reload();
			vm.modal.remove();
		}

		if (vm.product.services && vm.product.services.length) vm.tab = 'services'
		else vm.tab = vm.product.accessories[0].id;

		vm.switchTab = id => {
			vm.tab = id;
			$ionicScrollDelegate.scrollTop();
			$ionicScrollDelegate.resize();
		}

		$scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
           vm.modal.remove();
       })

	}
}

export default component;


// WEBPACK FOOTER //
// ./app/components/upsell/upsell.component.js